import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as my from '@alipay/smallfish-bridge-my';
export function _sendBatch(params) {
  var datas = params.datas,
    dataCache = params.dataCache,
    server = params.server,
    platform = params.platform;
  datas.forEach( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
      var value, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            value = "data=".concat(encodeURIComponent(data === null || data === void 0 ? void 0 : data.join()), "&time=").concat(new Date().getTime());
            if (!(platform === 'cabin')) {
              _context.next = 4;
              break;
            }
            cabinRequest(server, data, dataCache);
            return _context.abrupt("return");
          case 4:
            if (!(platform === 'mini')) {
              _context.next = 7;
              break;
            }
            sendMiniData(server, data, dataCache);
            return _context.abrupt("return");
          case 7:
            if (!(platform === 'alipayHk')) {
              _context.next = 10;
              break;
            }
            sendHkWallet(server, data, dataCache);
            return _context.abrupt("return");
          case 10:
            if (!supportsSendBeacon()) {
              _context.next = 19;
              break;
            }
            _context.next = 13;
            return sendBeacon(value, server);
          case 13:
            res = _context.sent;
            if (res) {
              _context.next = 17;
              break;
            }
            _context.next = 17;
            return sendFetchData(server, data, dataCache);
          case 17:
            _context.next = 21;
            break;
          case 19:
            _context.next = 21;
            return sendFetchData(server, data, dataCache);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
export function sendMiniData(server, data, dataCache) {
  return new Promise(function (resolve, reject) {
    if (typeof my !== 'undefined') {
      my.request({
        url: server,
        method: 'GET',
        data: {
          data: "".concat(data.join(), "&time=").concat(new Date().getTime())
        },
        headers: {
          'content-type': 'application/x-www-form-urlencoded'
        },
        dataType: 'json',
        success: function success() {
          resolve(true);
        },
        fail: function fail() {
          dataCache.unshift(data);
          reject(false);
        }
      });
    }
  });
}
export function sendHkWallet(server, data, dataCache) {
  my.request({
    url: server,
    method: 'GET',
    data: {
      data: "".concat(data.join(), "&time=").concat(new Date().getTime())
    },
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    dataType: 'json',
    success: function success() {
      return true;
    },
    fail: function fail() {
      dataCache.unshift(data);
      throw false;
    }
  });
}
export function sendBeacon(value, server) {
  return new Promise(function (resolve) {
    var headers = {
      type: 'application/x-www-form-urlencoded'
    };
    var blob = new Blob([value], headers);
    var res = navigator.sendBeacon(server, blob);
    resolve(res);
  });
}

/**
 * 是否支持SendBeacon
 * @return {boolean}
 */
export function supportsSendBeacon() {
  if (navigator && navigator.sendBeacon && typeof navigator.sendBeacon === 'function' && Blob && typeof Blob === 'function') {
    return true;
  }
  return false;
}

/**
 * FETCH POST 发送
 * @param server
 * @param data
 * @param dataCache
 */
export function sendFetchData(server, data, dataCache) {
  return new Promise(function (resolve, reject) {
    fetch(server, {
      method: 'POST',
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      },
      keepalive: true,
      body: "data=".concat(encodeURIComponent(data.join()), "&time=").concat(new Date().getTime())
    }).then(function (response) {
      if (!response.ok) {
        dataCache.unshift(data);
        reject();
        return;
      }
      resolve(response === null || response === void 0 ? void 0 : response.ok);
    }).catch(function () {
      dataCache.unshift(data);
    });
  });
}

/**
 * cabin发送日志和性能数据
 * @param params
 */
export function cabinRequest(server, data, dataCache) {
  var headers = {
    'Content-type': 'application/x-www-form-urlencoded'
  };
  var requestData = "".concat(data.join(), "&time=").concat(new Date().getTime());
  var callback = function callback() {};
  try {
    ac.call('httpRequest', {
      url: server,
      headers: headers,
      method: 'POST',
      data: requestData,
      timeout: 1000
    }, callback);
  } catch (error) {
    dataCache.unshift(data);
  }
}